module.exports = __webpack_public_path__ + "media/fonts/IntroRegular-2f43b315.woff";